export default function Terms() {
  return (
    <div style={styles.container}>
      <h1>Términos y Condiciones</h1>

      <p>Korners es un servicio operado por Daniel Rubies Isla en México.</p>

      <h3>1. Uso del sitio</h3>
      <p>El sitio permite visualizar recorridos virtuales con fines informativos.</p>

      <h3>2. Naturaleza del servicio</h3>
      <p>
        Los recorridos son representaciones visuales y pueden no reflejar
        condiciones actuales del inmueble.
      </p>

      <h3>3. Sin garantías</h3>
      <p>
        No se garantiza disponibilidad continua ni resultados comerciales.
      </p>

      <h3>4. Propiedad intelectual</h3>
      <p>
        El contenido pertenece a los clientes o a Korners. Queda prohibida su reproducción.
      </p>

      <h3>5. Limitación de responsabilidad</h3>
      <p>
        Korners no será responsable por decisiones o daños derivados del uso del sitio.
      </p>

      <h3>6. Infraestructura externa</h3>
      <p>
        El servicio depende de terceros como Supabase y Vercel.
      </p>

      <h3>7. Modificaciones</h3>
      <p>Los términos pueden modificarse en cualquier momento.</p>

      <h3>8. Jurisdicción</h3>
      <p>Leyes de México, tribunales de Nuevo León.</p>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    maxWidth: "800px",
    margin: "auto",
    lineHeight: "1.6",
  },
};